var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.RespondComponent, _vm._g(_vm._b({
    tag: "component",
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs,
          on
        })];
      }
    }], null, true)
  }, 'component', {
    value: _vm.value,
    program: _vm.program,
    isGranted: _vm.isGranted
  }, false), {
    input: _vm.input
  }));

}
var staticRenderFns = []

export { render, staticRenderFns }